const FOCUSABLE_SELECTOR =
    'a[href], area[href], input:not([disabled]):not([type="hidden"]), ' +
    "select:not([disabled]), textarea:not([disabled]), button:not([disabled]), " +
    'iframe, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

function setCookie(name, value, days) {
    const maxAge = days * 24 * 60 * 60;

    document.cookie =
        encodeURIComponent(name) + "=" + encodeURIComponent(value) + "; path=/" + "; max-age=" + maxAge + "; SameSite=Lax";
}

function getCookie(name) {
    const encodedName = encodeURIComponent(name) + "=";
    const cookies = document.cookie.split(";");

    for (let c of cookies) {
        c = c.trim();
        if (c.indexOf(encodedName) === 0) {
            return decodeURIComponent(c.substring(encodedName.length));
        }
    }

    return null;
}

function getCookieName(element) {
    return "alert_closed_" + element.id;
}

function closeElementWithCookie(element, options) {
    if (!element || element.dataset.isClosing === "true") {
        return;
    }

    const settings = options || {};
    element.dataset.isClosing = "true";

    setCookie(getCookieName(element), "true", 30);

    if (settings.collapse) {
        element.style.transition = "opacity 0.3s ease, height 0.3s ease";
        element.style.opacity = "0";
        element.style.height = "0";
        element.style.overflow = "hidden";
    } else {
        element.style.transition = "opacity 0.3s ease";
        element.style.opacity = "0";
    }

    setTimeout(function () {
        if (typeof settings.onAfterClose === "function") {
            settings.onAfterClose();
        }
        element.remove();
    }, 300);
}

function getFocusableElements(container) {
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (element) {
        return (
            !element.hasAttribute("hidden") &&
            element.getAttribute("aria-hidden") !== "true" &&
            (element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement)
        );
    });
}

function trapFocus(event, dialog) {
    if (event.key !== "Tab") {
        return;
    }

    const focusableElements = getFocusableElements(dialog);

    if (!focusableElements.length) {
        event.preventDefault();
        dialog.focus();
        return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
    }
}

function initSingleAlertBar(bar) {
    if (!bar || bar.dataset.alertInitialized === "true") {
        return;
    }

    bar.dataset.alertInitialized = "true";

    if (!bar.id) {
        return;
    }

    const closeBtn = bar.querySelector(".alrt-close");

    if (!getCookie(getCookieName(bar))) {
        bar.style.display = "block";
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", function () {
            closeElementWithCookie(bar, { collapse: true });
        });
    }
}

function openLightBox(lightBox) {
    const dialog = lightBox.querySelector(".modalAlertLightBox-dialog");
    const title = lightBox.querySelector(".alert-box-title");
    const closeBtn = lightBox.querySelector(".alrt-close");
    const focusTarget = title || closeBtn || dialog;

    lightBox.__previouslyFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;

    lightBox.hidden = false;
    lightBox.style.display = "flex";
    lightBox.setAttribute("aria-hidden", "false");
    document.body.classList.add("modal-alert-open");

    window.requestAnimationFrame(function () {
        if (focusTarget) {
            focusTarget.focus();
        }
    });
}

function closeLightBox(lightBox) {
    if (!lightBox) {
        return;
    }

    const previousFocus = lightBox.__previouslyFocusedElement;

    lightBox.setAttribute("aria-hidden", "true");
    document.body.classList.remove("modal-alert-open");

    closeElementWithCookie(lightBox, {
        onAfterClose: function () {
            if (previousFocus && document.contains(previousFocus)) {
                previousFocus.focus();
            }
        },
    });
}

function initSingleAlertLightBox(lightBox) {
    if (!lightBox || lightBox.dataset.alertInitialized === "true") {
        return;
    }

    lightBox.dataset.alertInitialized = "true";

    if (!lightBox.id || lightBox.dataset.preview === "true") {
        return;
    }

    const dialog = lightBox.querySelector(".modalAlertLightBox-dialog");
    const closeBtn = lightBox.querySelector(".alrt-close");

    if (!getCookie(getCookieName(lightBox))) {
        openLightBox(lightBox);
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", function () {
            closeLightBox(lightBox);
        });
    }

    lightBox.addEventListener("click", function (event) {
        if (event.target === lightBox) {
            closeLightBox(lightBox);
        }
    });

    lightBox.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            event.preventDefault();
            closeLightBox(lightBox);
            return;
        }

        if (dialog) {
            trapFocus(event, dialog);
        }
    });
}

function runInit() {
    document.querySelectorAll(".alrt-bar").forEach(initSingleAlertBar);
    document.querySelectorAll(".modalAlertLightBox").forEach(initSingleAlertLightBox);
}

export function aaalifeAlertBarInit() {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", runInit, { once: true });
    } else {
        runInit();
    }
}
